import moment from "moment";

export const createOrderFilterDefaults = (now = new Date()) => ({
  search: "",
  phone: "",
  status: { value: null, label: "All order statuses" },
  paymentMethod: { value: null, label: "All payment methods" },
  category: null,
  fromDate: moment(now).subtract(100, "years").toDate(),
  toDate: moment(now).add(100, "years").toDate(),
  pageSize: 10,
  includeDummy: false,
});

export const isDefaultDateRange = (fromDate, toDate, defaults) =>
  moment(fromDate).isSame(moment(defaults.fromDate), "day") &&
  moment(toDate).isSame(moment(defaults.toDate), "day");

export const getActiveOrderFilters = (values, defaults) => {
  const filters = [];

  if (values.search?.trim()) {
    filters.push({ key: "search", label: `Search: ${values.search.trim()}` });
  }

  const phone = values.phone?.replaceAll("_", "").trim();
  if (phone) {
    filters.push({ key: "phone", label: `Phone: ${phone}` });
  }

  if (values.status?.value) {
    filters.push({ key: "status", label: `Status: ${values.status.label}` });
  }

  if (values.paymentMethod?.value) {
    filters.push({
      key: "paymentMethod",
      label: `Payment: ${values.paymentMethod.label}`,
    });
  }

  if (values.category?.value) {
    filters.push({
      key: "category",
      label: `Category: ${values.category.label}`,
    });
  }

  if (!isDefaultDateRange(values.fromDate, values.toDate, defaults)) {
    filters.push({
      key: "dateRange",
      label: `Date: ${moment(values.fromDate).format("DD MMM YYYY")} – ${moment(
        values.toDate
      ).format("DD MMM YYYY")}`,
    });
  }

  if (Number(values.pageSize) !== Number(defaults.pageSize)) {
    filters.push({ key: "pageSize", label: `${values.pageSize} per page` });
  }

  if (values.includeDummy) {
    filters.push({ key: "includeDummy", label: "Including dummy orders" });
  }

  return filters;
};
